<script lang="ts">
	import { onMount, getContext } from 'svelte';
	import { format } from 'svelte-i18n';

	import {
		getDeviceRoomList,
		getAllDevicesByRoomID,
		getMappedRoomList,
	} from '../../../Lists/list-helpers';
	import { capFirstChar } from 'src/helpers/utilities';

	//Design system components
	import { Alert, Container } from '@Shelly/shelly-design-system';

	import CreateNewRoom from 'src/components/Lists/Rooms/CreateNewRoom.svelte';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { is_gen_z } from 'src/helpers/interface_helpers';
	import { DEVICES_WITH_MODE_CHANGE } from 'src/constants';

	export let editDevice;
	export let selectedRef: HTMLElement = null;
	export let requestLoader: boolean = false;
	export let updateFullHeight;

	let deviceRoomListDB = [];
	let allRoomsRefs: { [key: string | number]: HTMLElement } = {};

	let newRoom, newRoomEditing;

	let newRoomStore: SvelteStore<any> = getContext('newRoomStore');
	let isMounted = false;

	$: {
		({ newRoom, newRoomEditing } = $newRoomStore);
		if (newRoom !== undefined) {
			updateFullHeight = newRoomEditing;
			editDevice = {
				...editDevice,
				room_id: newRoom.id,
			};
			$newRoomStore = {
				newRoom: undefined,
				newRoomEditing: false,
			};
		}

		updateFullHeight = newRoomEditing;
	}

	$: deviceRoomListMapped = getMappedRoomList(deviceRoomListDB, editDevice.room_id);

	$: if (newRoomEditing === false && isMounted) {
		deviceRoomListDB = getDeviceRoomList();
	}

	const onSelectRoom = (room) => {
		let devicePosition = editDevice.position;
		// Set device new position to be last in the new room selected
		if (room.id != editDevice.room_id) {
			const allDevicesFromNewRoom = getAllDevicesByRoomID(room.id);

			const newRoomDeviceLastPosition =
				allDevicesFromNewRoom.length > 0
					? allDevicesFromNewRoom.reduce((prev, current) =>
							prev.position > current.position ? prev : current,
						)
					: { position: 0 };

			devicePosition = newRoomDeviceLastPosition.position + 1;
		}

		editDevice = {
			...editDevice,
			position: devicePosition,
			room_id: room.id,
		};
	};

	$: selectedRef = allRoomsRefs[editDevice.room_id];
	// $: isGenZ = is_gen_z(editDevice);

	onMount(() => {
		deviceRoomListDB = getDeviceRoomList();
		isMounted = true;
	});
</script>

<Container noScroll padding="0">
	{#if requestLoader && !DEVICES_WITH_MODE_CHANGE.includes(editDevice.type)}
		<!-- <Loader size="l" class="d-flex justify-content-center mb-m" />
	{#if isGenZ}
		<Text class="text-center mt-s mb-m" styleType="body-small"
			>{$format('label_pairing_instructions', {
				default:
					'For faster pairing unplug your device for 5 seconds and plug it back.'
			})}</Text
		>
		<Alert
			type="info"
			heading={capFirstChar(
				$format('include_device_state_associate', {
					default: 'Pairing, device with selected gateway.'
				})
			)}
		/>
	{:else}
		<Alert
			type="info"
			heading={capFirstChar(
				$format('add_device_state_associate', {
					default: 'associating, device with your account'
				})
			)}
		/>
	{/if} -->
	{:else if newRoomEditing}
		<CreateNewRoom on:after-room-update />
	{:else}
		{#if editDevice?.bundle}
			<Alert
				type="info"
				class="mb-m"
				heading={capFirstChar(
					$format('alert_add_device_bundle_info', {
						default:
							'This device is a part of a bundle. All devices from the bundle will be automatically added to the same room you select.',
					}),
				)}
			/>
		{/if}

		<SelectList
			showTitle={false}
			list={deviceRoomListMapped}
			variant="radio"
			bind:allCardsRefs={allRoomsRefs}
			on:click={(e) => onSelectRoom(e.detail)}
		/>
	{/if}
</Container>
